
<template>
  <div class="card">
        <h5>{{editingCustomer ? 'Edit Customer' : 'New Customer'}}</h5>
        <p v-if="isGlobalCustomer" class="validation-error">You are not able to edit global customers at this time</p>
        <hr>
        
        <div class="container p-0 m-0">
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="TBGA" label="JDE #" v-model="customer.JdeNum"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput 
                placeholder="DentaSmile" 
                label="Business Name" 
                :disabled="isGlobalCustomer"
                v-model="customer.Name"
                :validator="$v.customer.Name"
                :validatorMsgMap="MsgMap"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput 
                placeholder="John" 
                label="First Name" 
                :disabled="isGlobalCustomer"
                v-model="customer.CustomerContact.FirstName"
                :validator="$v.customer.CustomerContact.FirstName"
                :validatorMsgMap="MsgMap"/>
            </div>
            <div class="col">
              <BasicTextInput 
                placeholder="Smith" 
                label="Last Name" 
                :disabled="isGlobalCustomer"
                v-model="customer.CustomerContact.LastName"
                :validator="$v.customer.CustomerContact.LastName"
                :validatorMsgMap="MsgMap"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <PhoneNumberInput :disabled="isGlobalCustomer" placeholder="(513)600-7085" label="Phone #" v-model="customer.CustomerContact.PhoneNumber"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="Address Line 1" label="Address Line 1" v-model="customer.Address.Line1"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="Suite" label="Suite" v-model="customer.Address.Line2"/>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="City" label="City" v-model="customer.Address.City"/>
            </div>
            <div class="col">
              <StateSelect :disabled="isGlobalCustomer" placeholder="" label="State" v-model="customer.Address.StateId"/>
            </div>
            <div class="col">
              <ZipCodeInput :disabled="isGlobalCustomer" placeholder="Zip" label="Zip" v-model="customer.Address.ZipCode"/>
            </div>
          </div>
        </div>
       <div class="btn-wrapper">
          <button type="button" class="btn btn-secondary" @click="$emit('cancelPrivateCustomer')">Cancel</button>
          <button type="button" :disabled="isGlobalCustomer" class="btn btn-primary" @click="savePrivateCustomer">{{editingCustomer ? 'Save' : 'Add Customer'}}</button>
         </div>
      </div>
</template>

<script>
import { CustomerService } from '@/services';
import { validatorMsgMapBase, deepCopyObject } from "../modules/helpers";
import {
    required,
    requiredIf
} from 'vuelidate/lib/validators';

export default {
  name: 'PrivateCustomerForm',
  props:{
    value:{
      type: Object,
      default: () => {
        //fill in customerdetails
      }
    },
    editingCustomer: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      validatorMsgMapBase: validatorMsgMapBase,
      emptyCustomer: {Id: 0,
        JdeNum: '',
        Name: '',
        LicenseNumber: null,
        Specialty: null,
        PhoneNum: '',
        FaxNum: '',
        Addresses: [],
        CustomerContact: {
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          Email: null,
        },
        Address: {
          AddressId: 0,
          Name: '',
          Line1: '',
          Line2: '',
          City: '',
          StateId: null,
          ZipCode: '',
          LocationCode: '',
        },
        IsPrivate: true
      },
      customer: this.value,
      // responseCustomer: {}
    }
  },
  validations() {
    return {
      customer: {
        Name: {
          required :  requiredIf(function(customer){
        	              return !(customer.CustomerContact.FirstName || customer.CustomerContact.LastName); 
                      }),
        },
        CustomerContact: {
          FirstName: {
            required : requiredIf(function(){
        	              return !(this.customer.Name); 
                      }),
          },
          LastName: {
            required : requiredIf(function(){
        	              return !(this.customer.Name); 
                      }),
          }
        }
        
      }
    }
  },
  methods: {
    savePrivateCustomer(){
      console.log('saved', this.customer)
      this.customer.Addresses = [{...this.customer.Address}]
      
      if (this.$v.customer.$invalid){
        this.$v.customer.$touch();
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
        return;
      }
      if(this.editingCustomer){
        this.updateCustomer()
      } else {
        this.createNewCustomer()
      }
      this.customer = deepCopyObject(this.emptyCustomer);
      // this.$emit('privateCustomerSaved', this.customer)
    },
    createNewCustomer(){
      CustomerService.create(this.customer)
        .then(res => {
          console.log(res)
          this.$emit('privateCustomerSaved', res)
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'New private customer created', type: 'success' });
        })
        .catch(err => {
          console.log(err)
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to create customer at this time', type: 'error' });
        })
    },
    updateCustomer(){
      CustomerService.update(this.customer)
        .then(res => {
          console.log(res)
          this.$emit('privateCustomerSaved', res)
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer updated', type: 'success' });
        })
        .catch(err => {
          console.log(err)
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to update customer at this time', type: 'error' });
        })
    },
    setCustomer(){
      if(this.customer.CustomerContact === null){
        this.customer.CustomerContact = this.emptyCustomer.CustomerContact;
      }
      if(this.customer.Address === null){
        this.customer.Address = this.emptyCustomer.CustomerContact;
      }
    }
  },
  computed: {
    MsgMap(){
      return {
        ...this.validatorMsgMapBase,
        required:  'Name is Required',
      };
    },
    isGlobalCustomer(){
      return !this.customer.IsPrivate
    }
  },
  created(){
    this.setCustomer();
  }
}
</script>

<style lang="scss" scoped>
  .card{ 
    padding: 25px;
    .modal-card {
      background-color: white;
    }
  }
  .btn-wrapper{
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      margin: 5px;
    }
  }
</style>